"use strict";

import AppUtil from "/js/util/app-util.js";
import AnimSequencer from "/js/util/anim-sequencer.js";

/**
 * App-specific convention for fading-in and fading-out elements.
 *
 * When used, `fadeIn` and `fadeOut` should be used as a pair.
 *
 * If `fadeIn/fadeOut` is used on an element, synchronous shows/hides on that
 * same element should be done via `fadeInNow/fadeOutNow`.
 *
 * Uses `visibility` property only, does not touch `display`. [TODO: Not true, see below]
 * Ie, not meant for elements that are in document flow.
 */
export default class FadeUtil {

  /**
   * Element must have transition:opacity defined.
   */
  static fadeIn($element, callback) {
    const f = () => {
      $element.removeClass('fadeToHidden');
      $element.addClass('fadeFromHidden');
    };

    // TODO: This is problematic because it explicitly adds "display:block" as a style,
    //  overriding any carefully constructed css class hierarchy values.
    //  Probably should remove this, but will have implications and need regression testing.
    $element.show();

    AnimSequencer.runOne($element, f, callback);
  }

  static fadeOut($element, callback) {
    const f = () => {
      $element.removeClass('fadeFromHidden');
      $element.addClass('fadeToHidden');
    };
    AnimSequencer.runOne($element, f, callback);
  }

  /**
   * For use on elements that typically use an asynchronous transition, but
   * sometimes need to be shoown synchronously.
   */
  static fadeInNow($element) {
    AppUtil.setCssWithoutTransition($element, () => {
      $element.removeClass('fadeToHidden');
      $element.removeClass('fadeFromHidden');
      $element.css("visibility", 'visible');
      $element.css("opacity", 1);
    });
  }

  static fadeOutNow($element) {
    AppUtil.setCssWithoutTransition($element, () => {
      $element.removeClass('fadeToHidden');
      $element.removeClass('fadeFromHidden');
      $element.css("visibility", 'invisible');
      $element.css("opacity", 0);
    });
  }

}